<div class="flex h-full min-h-0 flex-col">
  <div class="relative z-30 shrink-0 bg-white pb-2">
    <div class="mb-3 flex h-10 items-center">
      <aw-section-headline size="medium">
        {{ cmsTextProvider.sortiment.ticketSortGroups }}
      </aw-section-headline>
    </div>
    <div class="flex flex-wrap items-center gap-3">
      <aw-search-bar
        class="min-w-40 flex-1"
        appearance="comfortable"
        [formControl]="filterForm.controls.search"
        [placeholder]="cmsTextProvider.sortiment.searchPlaceholder">
      </aw-search-bar>

      <div class="relative shrink-0">
        <button
          type="button"
          class="border-standard-outline-light hover:bg-standard-hover-main flex h-10 cursor-pointer items-center gap-1.5 rounded-md border px-3 text-base"
          aria-haspopup="menu"
          [attr.aria-expanded]="isSortMenuOpen()"
          (click)="isSortMenuOpen.set(!isSortMenuOpen())">
          <span class="material-symbols-rounded text-xl!" aria-hidden="true">
            sort
          </span>
          <span>{{ cmsTextProvider.sortiment.sortPlaceholder }}</span>
          <span class="material-symbols-rounded text-xl!" aria-hidden="true">
            keyboard_arrow_down
          </span>
        </button>

        @if (isSortMenuOpen()) {
          <div
            awCloseOnOffClick
            role="menu"
            (onOffClick)="isSortMenuOpen.set(false)"
            class="border-standard-outline-light absolute top-full left-0 z-20 mt-1 w-48 overflow-hidden rounded-lg border bg-white py-1 shadow-lg">
            @for (option of sortOptions; track option.value) {
              <button
                type="button"
                role="menuitem"
                class="hover:bg-standard-hover-main flex w-full cursor-pointer items-center justify-between px-4 py-3 text-left text-base"
                [class.bg-standard-selected]="selectedSort() === option.value"
                (click)="selectSort(option.value)">
                <span>{{ option.label }}</span>
                @if (selectedSort() === option.value) {
                  <span
                    class="material-symbols-rounded text-lg!"
                    aria-hidden="true">
                    check
                  </span>
                }
              </button>
            }
          </div>
        }
      </div>
      <div class="relative shrink-0">
        <button
          type="button"
          class="border-standard-outline-light hover:bg-standard-hover-main flex h-10 cursor-pointer items-center gap-1.5 rounded-md border px-3 text-base"
          aria-haspopup="menu"
          [attr.aria-expanded]="isFilterMenuOpen()"
          (click)="isFilterMenuOpen.set(!isFilterMenuOpen())">
          <span class="material-symbols-rounded text-xl!" aria-hidden="true">
            filter_list
          </span>
          <span>{{ cmsTextProvider.sortiment.filterPlaceholder }}</span>
        </button>

        @if (isFilterMenuOpen()) {
          <div
            awCloseOnOffClick
            role="menu"
            (onOffClick)="isFilterMenuOpen.set(false)"
            class="border-standard-outline-light absolute top-full right-0 z-20 mt-1 w-64 rounded-xl border bg-white p-4 shadow-lg">
            <div class="flex flex-col gap-3">
              <div class="flex flex-col gap-1">
                <div class="text-base font-medium">
                  {{ cmsTextProvider.sortiment.filterType }}
                </div>
                <aw-multi-select-drop-down
                  id="ticket-type-filter"
                  appearance="compact"
                  [formControl]="filterForm.controls.filterType"
                  [options]="ticketTypes"
                  name="name"
                  valueAttribute="value"
                  [placeholder]="cmsTextProvider.sortiment.typePlaceholder" />
              </div>
              <div class="flex flex-col gap-1">
                <div class="text-base font-medium">
                  {{ cmsTextProvider.sortiment.filterStatus }}
                </div>
                <aw-drop-down
                  id="ticket-status-filter"
                  appearance="compact"
                  [formControl]="filterForm.controls.filterStatus"
                  [options]="ticketStatuses"
                  [searchable]="false"
                  [showClearOption]="true"
                  [clearOptionLabel]="cmsTextProvider.sortiment.notSpecified"
                  name="name"
                  valueAttribute="value"
                  [placeholder]="cmsTextProvider.sortiment.statusPlaceholder" />
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
  @if (filteredTickets().length !== 0) {
    <aw-section
      [withoutContentPadding]="true"
      class="border-standard-outline-light mt-2 block min-h-0 w-full flex-1 overflow-y-auto rounded-lg border"
      testIdAffix="ticket-sort-buttons">
      <div class="flex flex-col gap-1 p-3">
        @for (ticketSort of filteredTickets(); track ticketSort.id) {
          <aw-ticket-sort-button
            [ticketSort]="ticketSort"
            [isSelected]="selectedTicketId() === ticketSort.id"
            [isEdited]="editedTicketIds().has(ticketSort.id)"
            [isLayoutCompleted]="completedLayoutTicketIds().has(ticketSort.id)"
            (click)="ticketSelected.emit(ticketSort.id)" />
        }
      </div>
    </aw-section>
  }
</div>
